<template>
  <v-form
    ref='surgeriesForm'>
    <v-card
      v-for="(surgery, i) in user.health.surgeries"
      v-bind:key="i"
      class=condCard>
      <v-text-field
        v-model="user.health.surgeries[i].name"
        label="What kind of surgery was this?">
      </v-text-field>

      <span
        style="color: #8e8e8e">
        When did you have this surgery? (Approximate if exact date isn't known.)
      </span>
      <DateQuest
        :data="user.health.surgeries"
        :modifyIndex="i"/>

      <v-textarea
        v-model="surgery.details"
        :label="`Please add any extra details about this surgery.`"></v-textarea>
      <v-btn
        right
        depressed
        color="red"
        class="right white--text"
        @click="remove(surgery)">
        Remove
      </v-btn>
    </v-card>
    <center>
      <v-btn
        class="padded white--text"
        color="green"
        @click="addCond">
        Add surgery
      </v-btn>
    </center>
  </v-form>
</template>


<script>
import { mapFields } from "vuex-map-fields";
import DateQuest from "./DateQuest"
export default {
  props: {
    modifyData: Array,
    modifyIndex: Number
  },
  components: {
    DateQuest
  },
  mounted () {
  },
  methods: {
    remove (item) {
      const index = this.user.health.surgeries.indexOf(item);
      if (index >= 0)
        this.user.health.surgeries.splice(index, 1);
    },
    addCond() {
      var surgery = {
        type: '',
        date: '',
        details: ''
      };
      this.user.health.surgeries.push(surgery);
    }
  },
  data () {
    return {

    };
  },
  computed: {
    ...mapFields("patientQuestion", [
      "dataModel",
      "conditions",
      "conditionList"
    ]),
    ...mapFields([
      "user"
    ])
  }
};
</script>
<style>
.condCard {
  padding: 20px;
  margin: 5px;
}
.padded {
  margin: 5px 5px 5px 5px;
}
</style>
